import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { getPageLayoutType, decode_utf8 } from "../../../../common/utils/utilsFunc";
import classNames from 'classnames';
import ConsultStateRequestContextProvider, {
    ConsultStateRequestContext,
    ACTIONS
} from "../../context/ConsultStateRequestContextProvider";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const ConsultStateRequest = ({ props }) => {
    const [state, dispatch] = React.useContext(ConsultStateRequestContext);
    const [numApplication, setNumApplication] = React.useState();
    const [dateAdimission, setDateAdimission] = React.useState("");
    const [condition, setCondition] = React.useState("");
    const [nextStep, setNextStep] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [showBtn, setShowBtn] = React.useState(false);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    function verifNextStep() {
        if (!numApplication) {
            setError(true);
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");
        } else if (!verifReCaptcha && !getPageLayoutType()) {
            props.setGlobalAlert("Falta validar que no eres un Robot", "warning");

        } else {
            setError(false);
            setLoading(true);
            dispatch({
                payload: { numApp: numApplication, isSignedIn: getPageLayoutType() },
                type: ACTIONS.SET_SERV1,
            });
        }
    }

    React.useEffect(() => {
        setLoading(false);
        cleanErrors();
        const objResponse = state.response_serv1;

        if (objResponse) {
            if (objResponse?.code >= 0) {
                if (objResponse.code === 0) {
                    setCondition(objResponse.status);
                    setDateAdimission(objResponse.fecha);
                    setError(false)
                    if (objResponse.status === "Resuelto") {
                        setShowBtn(true);
                    } else {
                        setShowBtn(false);
                    }

                    setNextStep(true);
                } else if (objResponse.status === 500) {
                    props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");

                } else {
                    props.setGlobalAlert(decode_utf8(objResponse.mensaje), "warning", true, "Advertencia");

                }
            } else {
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");

            }
        }

    }, [state.response_serv1]);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            setError(false);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function getCard() {
        setLoading(true);
        dispatch({
            payload: { numApp: numApplication},
            type: ACTIONS.SET_SERV2,
        });

    }

    React.useEffect(() => {
        setLoading(false);
        cleanErrors();
        const objResponse = state.response_serv2;

        if (objResponse) {
            if (objResponse?.status === 500) {
                props.setGlobalAlert(objResponse?.message ? objResponse?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");


            } else if (objResponse?.status === 999) {
                props.setGlobalAlert(objResponse?.message ? objResponse?.message : "¡Por favor, no cierres la pestaña que se abrió!", "warning", true, "Advertencia");


            }
        }
    }, [state.response_serv2])

    function cleanErrors() {
        setError(false);
    }

    function cleanAll() {
        cleanErrors();
        setNextStep(false);
        setShowBtn(false);
        setCondition("");
        setDateAdimission("");
    }

    return (
        <CGE.Panel title={props.title_page_consulta_de_estado_de_solicitud} >
            <CGE.PanelContainer
                alingItensCenter={true}
                size="md"
            >
                <div
                    className={classNames(

                        {
                            'resp-forms': getPageLayoutType(),
                            'resp-forms-recaptcha': !getPageLayoutType(),
                        }
                    )}
                >
                    <div className="margin-state-request">
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Número de Solicitud"
                            handleChange={({ target }) => {
                                setNumApplication(target.value);
                                cleanAll();
                            }}
                            idFormElement="numApplication"
                            typeFormElement="text"
                            mandatoryElement={true}
                            typeElement="input-mask"
                            hasError={error && !numApplication}
                            value={numApplication}
                            msgError="Debes ingresar un Nro. de Solicitud"
                            maxLength={8}
                            formatChars={{
                                9: "[0-9]"
                            }}
                            mask="99999999"
                        />
                    </div>
                    {!getPageLayoutType() &&
                        <>
                            <CGE.FieldRecaptcha
                                horizontal={true}
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </>
                    }

                    <div className="d-flex justify-content-center" >
                        <CGE.Button
                            label="Buscar"
                            onClick={() => { verifNextStep() }}
                        />
                    </div>
                </div>
                {nextStep && (
                    <>
                        <CGE.Spacing type="nl" />
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Fecha Ingreso"
                            handleChange={({ target }) => setDateAdimission(target.value)}
                            idFormElement="dateAdimission"
                            typeFormElement="text"
                            typeElement={'input'}
                            readOnly={true}
                            value={dateAdimission}
                        />
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Estado"
                            handleChange={({ target }) => setCondition(target.value)}
                            idFormElement="condition"
                            typeFormElement="text"
                            typeElement={'input'}
                            readOnly={true}
                            value={condition}
                        />
                        {showBtn &&
                            <div className="d-flex justify-content-center" >
                                <CGE.Button
                                    label="Ver Carta Respuesta"
                                    type="ghost"
                                    onClick={() => { getCard() }}
                                />
                            </div>
                        }
                    </>
                )}
            </CGE.PanelContainer>
            {loading && <Loading />}
        </CGE.Panel>
    );
};

const ConsultStateRequestWithProvider = ({ props }) => (
    <ConsultStateRequestContextProvider>
        <ConsultStateRequest props={props} />
    </ConsultStateRequestContextProvider>
);
export default ConsultStateRequestWithProvider;